<template>
  <font-awesome-icon
    :icon="{ prefix: 'fab', iconName: 'twitter' }" />
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'

library.add(faTwitter)

export default {
  name: 'CoozzyTwitterIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-yellow;
  }
</style>
